import { Info } from 'lucide-react';

import { Button } from '@/_shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/_shared/components/ui/tooltip';

import { REGION_SCOPE_NOTE } from '../../lib/signup-regions';

/** Next to the region question: the region applies to the RudderStack workspace only. */
export function RegionScopeTooltip(): React.ReactElement {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="text"
          className="text-muted-foreground"
          aria-label="About the region"
          Icon={<Info />}
        />
      </TooltipTrigger>
      <TooltipContent>{REGION_SCOPE_NOTE}</TooltipContent>
    </Tooltip>
  );
}
